/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "кеше",
        "-2": "алдыңгүні",
        "0": "бүгін",
        "1": "ертең",
        "2": "бүрсігүні",
        "future": {
          "one": "{0} күннен кейін",
          "other": "{0} күннен кейін"
        },
        "past": {
          "one": "{0} күн бұрын",
          "other": "{0} күн бұрын"
        }
      },
      "day-narrow": {
        "-1": "кеше",
        "-2": "алдыңғы күні",
        "0": "бүгін",
        "1": "ертең",
        "2": "бүрсігүні",
        "future": {
          "one": "{0} күннен кейін",
          "other": "{0} күннен кейін"
        },
        "past": {
          "one": "{0} күн бұрын",
          "other": "{0} күн бұрын"
        }
      },
      "day-short": {
        "-1": "кеше",
        "-2": "алдыңғы күні",
        "0": "бүгін",
        "1": "ертең",
        "2": "бүрсігүні",
        "future": {
          "one": "{0} күннен кейін",
          "other": "{0} күннен кейін"
        },
        "past": {
          "one": "{0} күн бұрын",
          "other": "{0} күн бұрын"
        }
      },
      "hour": {
        "0": "осы сағат",
        "future": {
          "one": "{0} сағаттан кейін",
          "other": "{0} сағаттан кейін"
        },
        "past": {
          "one": "{0} сағат бұрын",
          "other": "{0} сағат бұрын"
        }
      },
      "hour-narrow": {
        "0": "осы сағат",
        "future": {
          "one": "{0} сағ. кейін",
          "other": "{0} сағ. кейін"
        },
        "past": {
          "one": "{0} сағ. бұрын",
          "other": "{0} сағ. бұрын"
        }
      },
      "hour-short": {
        "0": "осы сағат",
        "future": {
          "one": "{0} сағ. кейін",
          "other": "{0} сағ. кейін"
        },
        "past": {
          "one": "{0} сағ. бұрын",
          "other": "{0} сағ. бұрын"
        }
      },
      "minute": {
        "0": "осы минут",
        "future": {
          "one": "{0} минуттан кейін",
          "other": "{0} минуттан кейін"
        },
        "past": {
          "one": "{0} минут бұрын",
          "other": "{0} минут бұрын"
        }
      },
      "minute-narrow": {
        "0": "осы минут",
        "future": {
          "one": "{0} мин. кейін",
          "other": "{0} мин. кейін"
        },
        "past": {
          "one": "{0} мин. бұрын",
          "other": "{0} мин. бұрын"
        }
      },
      "minute-short": {
        "0": "осы минут",
        "future": {
          "one": "{0} мин. кейін",
          "other": "{0} мин. кейін"
        },
        "past": {
          "one": "{0} мин. бұрын",
          "other": "{0} мин. бұрын"
        }
      },
      "month": {
        "-1": "өткен ай",
        "0": "осы ай",
        "1": "келесі ай",
        "future": {
          "one": "{0} айдан кейін",
          "other": "{0} айдан кейін"
        },
        "past": {
          "one": "{0} ай бұрын",
          "other": "{0} ай бұрын"
        }
      },
      "month-narrow": {
        "-1": "өткен ай",
        "0": "осы ай",
        "1": "келесі ай",
        "future": {
          "one": "{0} айдан кейін",
          "other": "{0} айдан кейін"
        },
        "past": {
          "one": "{0} ай бұрын",
          "other": "{0} ай бұрын"
        }
      },
      "month-short": {
        "-1": "өткен ай",
        "0": "осы ай",
        "1": "келесі ай",
        "future": {
          "one": "{0} айдан кейін",
          "other": "{0} айдан кейін"
        },
        "past": {
          "one": "{0} ай бұрын",
          "other": "{0} ай бұрын"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "өткен тоқсан",
        "0": "осы тоқсан",
        "1": "келесі тоқсан",
        "future": {
          "one": "{0} тоқсаннан кейін",
          "other": "{0} тоқсаннан кейін"
        },
        "past": {
          "one": "{0} тоқсан бұрын",
          "other": "{0} тоқсан бұрын"
        }
      },
      "quarter-narrow": {
        "-1": "өткен тоқсан",
        "0": "осы тоқсан",
        "1": "келесі тоқсан",
        "future": {
          "one": "{0} тқс. кейін",
          "other": "{0} тқс. кейін"
        },
        "past": {
          "one": "{0} тқс. бұрын",
          "other": "{0} тқс. бұрын"
        }
      },
      "quarter-short": {
        "-1": "өткен тоқсан",
        "0": "осы тоқсан",
        "1": "келесі тоқсан",
        "future": {
          "one": "{0} тқс. кейін",
          "other": "{0} тқс. кейін"
        },
        "past": {
          "one": "{0} тқс. бұрын",
          "other": "{0} тқс. бұрын"
        }
      },
      "second": {
        "0": "қазір",
        "future": {
          "one": "{0} секундтан кейін",
          "other": "{0} секундтан кейін"
        },
        "past": {
          "one": "{0} секунд бұрын",
          "other": "{0} секунд бұрын"
        }
      },
      "second-narrow": {
        "0": "қазір",
        "future": {
          "one": "{0} сек. кейін",
          "other": "{0} сек. кейін"
        },
        "past": {
          "one": "{0} сек. бұрын",
          "other": "{0} сек. бұрын"
        }
      },
      "second-short": {
        "0": "қазір",
        "future": {
          "one": "{0} сек. кейін",
          "other": "{0} сек. кейін"
        },
        "past": {
          "one": "{0} сек. бұрын",
          "other": "{0} сек. бұрын"
        }
      },
      "week": {
        "-1": "өткен апта",
        "0": "осы апта",
        "1": "келесі апта",
        "future": {
          "one": "{0} аптадан кейін",
          "other": "{0} аптадан кейін"
        },
        "past": {
          "one": "{0} апта бұрын",
          "other": "{0} апта бұрын"
        }
      },
      "week-narrow": {
        "-1": "өткен апта",
        "0": "осы апта",
        "1": "келесі апта",
        "future": {
          "one": "{0} ап. кейін",
          "other": "{0} ап. кейін"
        },
        "past": {
          "one": "{0} ап. бұрын",
          "other": "{0} ап. бұрын"
        }
      },
      "week-short": {
        "-1": "өткен апта",
        "0": "осы апта",
        "1": "келесі апта",
        "future": {
          "one": "{0} ап. кейін",
          "other": "{0} ап. кейін"
        },
        "past": {
          "one": "{0} ап. бұрын",
          "other": "{0} ап. бұрын"
        }
      },
      "year": {
        "-1": "былтырғы жыл",
        "0": "биылғы жыл",
        "1": "келесі жыл",
        "future": {
          "one": "{0} жылдан кейін",
          "other": "{0} жылдан кейін"
        },
        "past": {
          "one": "{0} жыл бұрын",
          "other": "{0} жыл бұрын"
        }
      },
      "year-narrow": {
        "-1": "былтырғы жыл",
        "0": "биылғы жыл",
        "1": "келесі жыл",
        "future": {
          "one": "{0} ж. кейін",
          "other": "{0} ж. кейін"
        },
        "past": {
          "one": "{0} ж. бұрын",
          "other": "{0} ж. бұрын"
        }
      },
      "year-short": {
        "-1": "былтырғы жыл",
        "0": "биылғы жыл",
        "1": "келесі жыл",
        "future": {
          "one": "{0} ж. кейін",
          "other": "{0} ж. кейін"
        },
        "past": {
          "one": "{0} ж. бұрын",
          "other": "{0} ж. бұрын"
        }
      }
    },
    "locale": "kk"
  });
}